<script setup lang="ts">
import { onUnmounted, watch } from 'vue';

const props = defineProps<{
  errorMessage: string | null;
}>();

const emit = defineEmits<{
  clear: [];
}>();

let clearTimeoutId: ReturnType<typeof setTimeout> | null = null;

watch(() => props.errorMessage, (message) => {
  if (clearTimeoutId) {
    clearTimeout(clearTimeoutId);
    clearTimeoutId = null;
  }
  if (message) {
    clearTimeoutId = setTimeout(() => {
      emit('clear');
      clearTimeoutId = null;
    }, 5000);
  }
});

onUnmounted(() => {
  if (clearTimeoutId) {
    clearTimeout(clearTimeoutId);
  }
});
</script>

<template>
  <Transition name="toast">
    <div v-if="errorMessage" class="delete-error-toast" role="alert" aria-live="assertive">
      <span>{{ $t(errorMessage) }}</span>
    </div>
  </Transition>
</template>

<style scoped lang="css">
.delete-error-toast {
  position: fixed;
  width: 60%;
  font-size: var(--yb-text-sm);
  bottom: var(--yb-spacing-base, 16px);
  left: 50%;
  transform: translateX(-50%);
  background: var(--yb-color-error);
  color: white;
  padding: var(--yb-spacing-sm);
  border-radius: var(--yb-radius-sm);
  z-index: 1000;
  text-align: center;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
